{
  "plan_reminders": {
    "title": "We need you to confirm your SparkLayer plan",
    "confirm_plan": "We've updated your SparkLayer account and we just need you to confirm your new monthly billing",
    "select_plan": "You currently have no SparkLayer plan set up and we'll need you to confirm one before you go live"
  },
  "onboarding_actions": {
    "install": {
      "title": "Install SparkLayer for me",
      "description": "Our expert team can help integrate SparkLayer onto your website. It typically takes less than 1 working day.",
      "action": "Get started"
    },
    "book_call": {
      "title": "Book a free onboarding call",
      "description": "Our expert team is here to help! Book a call and we'll guide you through setting up SparkLayer and launching.",
      "action": "Book a call"
    }
  },
  "upsell_plan": {
    "sales_agents": {
      "title": "Sales Agent Ordering",
      "description": "Empower your sales team to place orders on behalf of your customers and manage their accounts."
    },
    "invoices": {
      "title": "Invoices",
      "description": "Automatically generate professional invoices that your customers can easily download."
    },
    "quoting": {
      "title": "Quoting",
      "description": "Enable an end-to-end \"quote to order\" experience and unify your sales team and B2B customers."
    },
    "company_users": {
      "title": "Company Users",
      "description": "Enable customers to create teams to share activities such as placing orders and managing addresses."
    },
    "api_access": {
      "title": "API Access",
      "description": "Build fully custom integrations and expand the power of SparkLayer with our Open API framework."
    }
  },
  "onboarding": {
    "badges": {
      "complete": "Completed",
      "pending": "Pending"
    },
    "checklist": {
      "title": "✅ Onboarding Checklist",
      "description": "Please tick the items below as you complete them:"
    },
    "connect": {
      "title": "Connect your {platform} store",
      "platform_fallback": "eCommerce",
      "subtitle_complete": "Your website is successfully connected to SparkLayer!",
      "subtitle_incomplete": "Select where you want to install SparkLayer",
      "not_connected": {
        "description": "You need to connect your website to SparkLayer before you can begin the onboarding process. It only takes a moment!",
        "action": "Connect your website"
      },
      "connected": {
        "description": "SparkLayer automatically connects to your website to synchronise product and customer data.",
        "sync_note": "Please note, data will still be synchronising even if you see errors.",
        "action": "View or update connected website"
      }
    },
    "frontend": {
      "title": "Enable the storefront B2B widgets",
      "subtitle_complete": "It looks like you've enabled the SparkLayer frontend widgets!",
      "subtitle_incomplete": "Activate and customise the SparkLayer Frontend on your website",
      "description": "To allow B2B customers to place orders, you'll need to install our special storefront widgets onto your website.",
      "checklist": {
        "installed": {
          "label": "The SparkLayer widgets have been added to your website",
          "description": "Our team has added the widgets for you, or you've added them yourself."
        },
        "advanced": {
          "label": "You've reviewed optional advanced configurations",
          "description": "Advanced configurations include settings up pack sizing, retail prices, automations and more.",
          "configurations_link": "View advanced configurations"
        }
      },
      "checklist_hint": "👉 You can also view our more in-depth frontend checklist",
      "action": "I've installed the B2B widgets",
      "action_undo": "Mark as not complete"
    },
    "sync": {
      "title": "Set up your B2B pricing",
      "subtitle_complete": "It looks like you've uploaded your B2B pricing!",
      "subtitle_incomplete": "Set up your price lists for your B2B customers",
      "description": "To setup your B2B pricing, you'll need to create a price list.",
      "get_started": "Get started",
      "checklist": {
        "created_list": {
          "label": "You've created your first price list in SparkLayer",
          "description": "You've followed the steps to set up either an automated or manual price list",
          "price_lists_link": "Go to price lists"
        },
        "advanced": {
          "label": "You've optionally reviewed more advanced pricing, e.g. quantity pricing and pack sizes",
          "description": "You've reviewed how quantity pricing and pricing rules such pack sizing work"
        }
      },
      "troubleshooting_hint": "Are you having issues uploading your B2B pricing? See our troubleshooting guide",
      "action": "I've uploaded my pricing",
      "action_undo": "Mark as not complete"
    },
    "settings": {
      "title": "Test as a B2B customer",
      "subtitle_complete": "It looks like you've configured your B2B customer groups!",
      "subtitle_incomplete": "Test SparkLayer on your website by logging in as a B2B customer",
      "customer_groups_link": "Customer groups",
      "description": "let you manage your B2B rules when you sign into your website.",
      "get_started": "Get started",
      "checklist": {
        "configured_group": {
          "label": "You've configured an example B2B customer group in SparkLayer",
          "description": "This includes a minimum order value, available payment method(s) and an associated price list",
          "groups_link": "Go to customer groups"
        },
        "has_customer": {
          "label": "You have a customer that you can log in with",
          "description": "You have a customer with the correct {term}(s) to match those in SparkLayer (e.g. b2b).",
          "shopify_link": "View customers in Shopify"
        },
        "placed_order": {
          "label": "You can place an order using SparkLayer on your website",
          "description": "You can add items to an order and checkout."
        },
        "order_visible": {
          "label": "Your order successfully appears in your website order admin",
          "description": "Once you've placed an order, you can view this in your website order admin.",
          "shopify_link": "View Shopify Draft Orders admin",
          "auto_convert_link": "Manage auto-convert settings"
        }
      },
      "action": "I've set my customer groups",
      "action_undo": "Mark as not complete"
    },
    "launch": {
      "title": "Invite customers & launch SparkLayer!",
      "subtitle_complete": "It looks like you've completed your tests!",
      "subtitle_incomplete": "Begin inviting customers and then launch your new B2B website",
      "description": "Once you've completed the steps above, we just need you to run some final tests before you're ready to launch your B2B website!",
      "checklist": {
        "familiar_with_invites": {
          "label": "You're familiar with how to invite your B2B customers",
          "description": "You've read our guide on how to invite customers to your website so they can begin placing orders."
        },
        "invited_customers": {
          "label": "You've invited at least 3 customers to your B2B store",
          "description": "You've invited some initial customers and they have successfully logged in."
        },
        "launched": {
          "label": "You've launched your new B2B store and you have customers actively using it",
          "description": "You've officially launched your new B2B store and you're ready to grow your B2B business!"
        }
      },
      "checklist_hint": "👉 You can also view our more in-depth launch checklist",
      "action": "I've completed the launch checks",
      "action_undo": "Mark as not complete"
    }
  }
}
